import axios from "axios";

export const handler = (data) => {
    console.log(data);
    const keys = Object.keys(data);
    const formData = new FormData();

    for (let i = 0; i < keys.length; i++) {
        if (keys[i] !== "images") {
            formData.append(keys[i], data[keys[i]]);
        }
    }

    if (data.images.length > 0) {
        for (let i = 0; i < data.images.length; i++) {
            formData.append("image", data.images[i]);
        }
    }
    let i = 0;
    for (var key of formData.entries()) {
        console.log(i + ", " + key[0] + ", " + key[1]);
        i++;
    }

    const config = {
        method: "post",
        url: "https://prod-06.northcentralus.logic.azure.com:443/workflows/1adbe0bfc3b24e8fb1a1d1bbb42aa34f/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=XBxL9tBdPIuVwQPuTlnh3sbHOkBaiGPRCAdB6XRCrLg",
        headers: {
            "content-type": "multipart/form-data",
        },
        data: formData,
    };
    axios(config).then((res) => console.log(res));
    return null;
};
